import { render, staticRenderFns } from "./BoxCostsList.vue?vue&type=template&id=714c51f7&scoped=true"
import script from "./BoxCostsList.vue?vue&type=script&lang=js"
export * from "./BoxCostsList.vue?vue&type=script&lang=js"
import style0 from "./BoxCostsList.vue?vue&type=style&index=0&id=714c51f7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c51f7",
  null
  
)

export default component.exports